<template>
    <div class="atSchool">

        <div class="welcomeDiv">
            <div class="welcomeWord">
                在校经历
            </div>
            <div class="welcomeTip">
                可添加多段在校经历
            </div>
        </div>
        <div class="formDiv" v-for="(item, indexs) in formShowList" :key="indexs">
            <div class="dataForm" v-if="item.formShow == true">
                <div class="closeForm" @click="closeForm(indexs)" v-if="indexs !== 0">
                    <van-icon name="cross" />
                </div>
                <div class="form">
                    <van-form label-width="300px">

                        <van-field readonly clickable :value="item.xueli" label="经历类型" placeholder="请选择在校经历类型"
                            @click="clickXueli(indexs)">
                            <template slot="right-icon">
                                <van-icon name="arrow" />
                            </template>
                        </van-field>
                        <div class="driverLine"></div>
                        <!-- 经历类型弹窗 -->
                        <van-popup v-model="item.xueliShow" position="bottom" round>
                            <van-picker title="在校经历类型" show-toolbar :columns="xueliList" @confirm="selectXueli"
                                @cancel="item.xueliShow = false" />
                        </van-popup>

                        <van-field readonly clickable :value="item.dateString" label="在校时间" placeholder="开始时间 -- 结束时间"
                            @click="clickDate(indexs)">
                            <template slot="right-icon">
                                <van-icon name="arrow" />
                            </template>
                        </van-field>
                        <div class="driverLine"></div>
                        <!-- 在校时间弹窗 -->
                        <van-popup v-model="item.dateShow" position="bottom" round>
                            <van-picker show-toolbar title="在校时间" :columns="columns" @cancel="item.dateShow = false"
                                @confirm="selectDate">
                            </van-picker>
                        </van-popup>

                        <div v-if="item.xueli !== '教职工'">
                            <van-field readonly clickable :value="item.college" label="学院" placeholder="请选择"
                                @click="clickCollegeInput(indexs)">
                                <template slot="right-icon">
                                    <van-icon name="arrow" />
                                </template>
                            </van-field>
                            <div class="driverLine"></div>
                        </div>
                        <!-- 学院弹窗 -->
                        <van-popup v-model="item.collegeShow" position="bottom" round>
                            <van-picker title="请选择" show-toolbar :columns="item.collegeName" @confirm="selectCollege"
                                @cancel="item.collegeShow = false" />
                        </van-popup>

                        <div v-if="item.xueli !== '教职工'">
                            <van-field v-model="item.major" label="专业" placeholder="请输入专业">
                            </van-field>
                            <div class="driverLine" style="margin-bottom: 20px;"></div>
                        </div>

                        <div v-if="item.xueli == '教职工'">
                            <van-field v-model="item.zhiwei" label="职务" placeholder="请输入职务">
                            </van-field>
                            <div class="driverLine" style="margin-bottom: 20px;"></div>
                        </div>

                        <div v-if="item.xueli == '教职工'">
                            <van-field v-model="item.staffId" label="职工号" placeholder="请输入职工号">
                            </van-field>
                            <div class="driverLine" style="margin-bottom: 20px;"></div>
                        </div>

                    </van-form>
                </div>
            </div>
        </div>

        <div class="addFormBtnDiv" @click="addForm" v-if="formShowList[3].formShow !== true">
            添加更多在校经历
        </div>

        <div class="nextIconDiv" @click="submit">
            <img src="../../assets/image/btn_xiayibu_nor.png" alt="" class='nextIcon'>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            atSchoolData: {
                xueli: '',
                xueji: '',
                xuejie: '',
                college: '',
                major: '',
                xueli2: '',
                xueji2: '',
                xuejie2: '',
                college2: '',
                xueli3: '',
                xueji3: '',
                xuejie3: '',
                college3: '',
                xueli4: '',
                xueji4: '',
                xuejie4: '',
                college4: '',
                major2: '',
                major3: '',
                major4: '',
                zhiwei: '',
                staffId: '',
            },
            xueliList: ['本科', '硕士', '博士', '博士后', '教职工', '专科', '继续教育'],
            formShowList: [{
                formShow: true,
                index: 1,
                xueli: '',
                xueji: '',
                xuejie: '',
                college: '',
                major: '',
                zhiwei: '',
                staffId: '',
                dateString: '',
                collegeName: [],
                xueliShow: false,
                dateShow: false,
                collegeShow: false,
            }, {
                formShow: false,
                index: 2,
                xueli: '',
                xueji: '',
                xuejie: '',
                college: '',
                major: '',
                zhiwei: '',
                staffId: '',
                dateString: '',
                collegeName: [],
                xueliShow: false,
                dateShow: false,
                collegeShow: false,
            }, {
                formShow: false,
                index: 3,
                xueli: '',
                xueji: '',
                xuejie: '',
                college: '',
                major: '',
                zhiwei: '',
                staffId: '',
                dateString: '',
                collegeName: [],
                xueliShow: false,
                dateShow: false,
                collegeShow: false,
            }, {
                formShow: false,
                index: 4,
                xueli: '',
                xueji: '',
                xuejie: '',
                college: '',
                major: '',
                zhiwei: '',
                staffId: '',
                dateString: '',
                collegeName: [],
                xueliShow: false,
                dateShow: false,
                collegeShow: false,
            }],
            columns: [
                // 第一列
                {
                    values: [],
                    defaultIndex: 2,
                },
                // 第二列
                {
                    values: [],
                    defaultIndex: 1,
                },
            ],
            arrayNum: ''
        };
    },
    created() {
        let date = new Date();
        let year = date.getFullYear(); //获取当前年份
        for (let i = year; i > 1909; i--) {
            this.columns[0].values.push(i);
        }
        this.columns[1].values.push('至今')
        for (let i = year + 4; i > 1909; i--) {
            this.columns[1].values.push(i);
        }
    },
    methods: {
        clickXueli(indexs) {
            this.arrayNum = indexs
            this.formShowList[indexs].xueliShow = true
        },
        selectXueli(value) {
            this.formShowList[this.arrayNum].xueli = value
            if (value == '教职工') {
                delete this.xueliList[4]
            }
            this.formShowList[this.arrayNum].xueliShow = false
        },
        clickDate(indexs) {
            this.arrayNum = indexs
            this.formShowList[indexs].dateShow = true
        },
        async selectDate(value) {
            this.formShowList[this.arrayNum].xueji = value[0]
            this.formShowList[this.arrayNum].xuejie = value[1]
            this.formShowList[this.arrayNum].dateString = value[0] + '-' + value[1]
            this.formShowList[this.arrayNum].dateShow = false;
            this.formShowList[this.arrayNum].collegeName = await this.getCollege(value);
        },
        // 获取学院信息
        async getCollege(value) {
            if (value[1] == '至今') {
                let date = new Date();
                let year = date.getFullYear();
                value[1] = year
            }
            const result = await this.$http.get("/xjcard/getFacultyList", {
                params: { xueji: value[0], xuejie: value[1] },
            });
            let collegeName = result.data.facultyList;
            return collegeName;
        },
        clickCollegeInput(indexs) {
            this.arrayNum = indexs
            this.formShowList[indexs].collegeShow = true
        },
        selectCollege(value) {
            this.formShowList[this.arrayNum].college = value
            this.formShowList[this.arrayNum].collegeShow = false
        },
        closeForm(indexs) {
            this.formShowList[indexs].formShow = false;
            this.formShowList[indexs].xueli = '';
            this.formShowList[indexs].xueji = '';
            this.formShowList[indexs].college = '';
            this.formShowList[indexs].major = '';
            this.formShowList[indexs].dateString = '';
            this.formShowList[indexs].zhiwei = '';
            this.formShowList[indexs].staffId = '';
        },
        addForm() {
            for (let i = 0; i < this.formShowList.length; i++) {
                if (this.formShowList[i].formShow == false) {
                    this.formShowList[i].formShow = true
                    break
                }
            }
        },
        submit() {
            for (let i = 3; i < this.formShowList.length; i--) {
                if (this.formShowList[i].formShow === true) {
                    if (this.formShowList[i].xueli === '教职工') {
                        if (this.formShowList[i].xueji === '' || this.formShowList[i].xuejie === '' || this.formShowList[i].staffId === '') {
                            this.$message("请填写信息");
                            return
                        } else {
                            if (this.formShowList[i].zhiwei !== '') {
                                this.atSchoolData.zhiwei = this.formShowList[i].zhiwei;
                                this.atSchoolData.staffId = this.formShowList[i].staffId;
                            }

                            this.atSchoolData.xueli = this.formShowList[0].xueli;
                            this.atSchoolData.xueji = this.formShowList[0].xueji;
                            this.atSchoolData.xuejie = this.formShowList[0].xuejie;
                            this.atSchoolData.college = this.formShowList[0].college;
                            this.atSchoolData.major = this.formShowList[0].major;

                            this.atSchoolData.xueli2 = this.formShowList[1].xueli;
                            this.atSchoolData.xueji2 = this.formShowList[1].xueji;
                            this.atSchoolData.xuejie2 = this.formShowList[1].xuejie;
                            this.atSchoolData.college2 = this.formShowList[1].college;
                            this.atSchoolData.major2 = this.formShowList[1].major;

                            this.atSchoolData.xueli3 = this.formShowList[2].xueli;
                            this.atSchoolData.xueji3 = this.formShowList[2].xueji;
                            this.atSchoolData.xuejie3 = this.formShowList[2].xuejie;
                            this.atSchoolData.college3 = this.formShowList[2].college;
                            this.atSchoolData.major3 = this.formShowList[2].major;

                            this.atSchoolData.xueli4 = this.formShowList[3].xueli;
                            this.atSchoolData.xueji4 = this.formShowList[3].xueji;
                            this.atSchoolData.xuejie4 = this.formShowList[3].xuejie;
                            this.atSchoolData.college4 = this.formShowList[3].college;
                            this.atSchoolData.major4 = this.formShowList[3].major;
                            console.log(this.atSchoolData)
                            this.gotoWorkData();
                        }
                    } else {
                        if (this.formShowList[i].xueli == '' || this.formShowList[i].xueji == '' || this.formShowList[i].xuejie == '' || this.formShowList[i].college == '' || this.formShowList[i].major == '') {
                            this.$message("请填写信息");
                            return
                        } else {
                            this.atSchoolData.xueli = this.formShowList[0].xueli;
                            this.atSchoolData.xueji = this.formShowList[0].xueji;
                            this.atSchoolData.xuejie = this.formShowList[0].xuejie;
                            this.atSchoolData.college = this.formShowList[0].college;
                            this.atSchoolData.major = this.formShowList[0].major;

                            this.atSchoolData.xueli2 = this.formShowList[1].xueli;
                            this.atSchoolData.xueji2 = this.formShowList[1].xueji;
                            this.atSchoolData.xuejie2 = this.formShowList[1].xuejie;
                            this.atSchoolData.college2 = this.formShowList[1].college;
                            this.atSchoolData.major2 = this.formShowList[1].major;

                            this.atSchoolData.xueli3 = this.formShowList[2].xueli;
                            this.atSchoolData.xueji3 = this.formShowList[2].xueji;
                            this.atSchoolData.xuejie3 = this.formShowList[2].xuejie;
                            this.atSchoolData.college3 = this.formShowList[2].college;
                            this.atSchoolData.major3 = this.formShowList[2].major;

                            this.atSchoolData.xueli4 = this.formShowList[3].xueli;
                            this.atSchoolData.xueji4 = this.formShowList[3].xueji;
                            this.atSchoolData.xuejie4 = this.formShowList[3].xuejie;
                            this.atSchoolData.college4 = this.formShowList[3].college;
                            this.atSchoolData.major4 = this.formShowList[3].major;
                            this.gotoWorkData();
                            return
                        }

                    }
                }
            }
        },
        gotoWorkData() {
            window.sessionStorage.setItem('atSchoolData',JSON.stringify(this.atSchoolData) )
            return this.$router.push({ path: "/workData" });
        }
    }
}
</script>

<style lang="less" scoped>
.atSchool {
    min-height: 100vh;
    background-color: #FFFFFF;

    .welcomeDiv {
        padding: 30px 5% 10px 5%;

        .welcomeWord {
            font-size: 2rem;
            font-weight: 400;
            color: #333333;
        }

        .welcomeTip {
            margin-top: 10px;
            font-weight: 400;
            color: #333333;
        }
    }

    .dataForm {
        position: relative;
        width: 90%;
        margin: 15px 5%;
        border: 1px solid #AAAAAA;
        border-radius: 15px;

        .closeForm {
            position: absolute;
            top: 2vw;
            right: 2vw;
        }

        .form {
            width: 90%;
            margin: 0 5%;
        }
    }

    .nextIconDiv {
        margin: 0 auto;
        padding: 20px 0;
        width: 20vw;
        height: 20vw;

        .nextIcon {
            width: 100%;
            height: 100%;
        }
    }

    .addFormBtnDiv {
        width: 80%;
        margin: 25px 10%;
        background: #00706E;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        padding: 10px 0;
        font-size: 1.3rem;
        border-radius: 45px;
    }
}

.driverLine {
    width: 100%;
    height: 1px;
    background: #AAAAAA;
}

.van-cell {
    margin-top: 30px !important;
    display: block !important;
    padding: 0 !important;
    font-size: 1.2rem !important;
}

.van-cell__title,
.labelName {
    font-weight: 400;
    font-size: 1.2rem;
    color: #333333;
}

.van-cell__value {
    font-size: 1.1rem;
    margin: 15px 1% 5px 1%;
    width: 98%;
}
</style>



// WEBPACK FOOTER //
// src/components/register/AtSchoolData.vue